import { Injectable } from '@angular/core';
import { Observable, Subject,BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShareDataService {
    private sharedProps:any = {};
    public tkn = null;
    public profilePic = null;
    public mobile = localStorage.getItem('mno');
    public amno = localStorage.getItem('amno');
    public passData = new Subject<any>();
    public filteredServiceList:any;
    public isSearchKey = new BehaviorSubject<any>(false);
    public filteredDeptList:any;
    public fetchHomeData = new Subject<any>();
    public updateFetchHomeData =new Subject<any>();
    public highlights =new Subject<any>();
    public recentlyViewed = new Subject<any>();
    public trendingData = new Subject<any>();
    public flagShip = new Subject<any>();
    public fhomeFallback = new Subject<any>();
    public categoryListData = new Subject<any>();
    public favouriteServiceData = new Subject<any>();
    private stateIdSource = new BehaviorSubject<any>(null);
    public shareStateData = new Subject<any>();
    public altNum = false;
    public notificationCatFlag = new Subject<any>();
    public profilePicture = new Subject<any>();
    public profileComplete = new Subject<any>();
    public editProfile = new Subject<any>();
    public filterData:any = null;
    public homeFetchData = new Subject<any>();
    public carousel = new Subject<any>();
    public transFilterData:any = null;
    public isLoginSuccess:any;
    public dropdownMenu:boolean = false;
    public profileCompleteValue = false;
    public searchFilter= new Subject<any>();
    public isFilterApply= new Subject<any>();
    public notificationDisable = new Subject<boolean>();
    public isSecurityQuestion= new Subject<any>();
    public isOneTimePopup:boolean = false;
    public isRating = false;
    public sortBy = 1;
    drawerState = false;

    public setValueByKey(key:any, value:any){
        this.sharedProps[`${key}`]=value;
    }
    
    public getValueByKey(key:any){
        return this.sharedProps[key];
    }

    sendStateId(message : any){
        this.stateIdSource.next({message});
    }

    getStateId() : Observable<any>{
      return this.stateIdSource.asObservable();   
    }

    
}